import React from "react";
import InfoTooltip from "@/components/UI/InfoTooltip";

interface PageHeaderProps {
  title: string;
  tooltipText: string;
  className?: string;
  dataTestId?: string;

  [key: string]: any;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  tooltipText,
  className = "text-[18px] font-bold",
  dataTestId,
  ...rest
}) => {
  return (
    <div className="flex items-center gap-1.5">
      <h1 className={className} {...rest}>
        {title}
      </h1>
      <InfoTooltip title={tooltipText} data-testid={dataTestId} />
    </div>
  );
};

export default PageHeader;
